/* eslint-disable @typescript-eslint/naming-convention */
enum AnalyticsEventName {
    EDITOR_TM_SUGGESTION_CLICKED = 'Editor - TM Suggestion Clicked - Client',
    EDITOR_CHANGE_LETTER_CASE = 'Editor - Change letter case - Client',
    EDITOR_MT_SUGGESTION_CLICKED = 'Editor - MT Suggestion Clicked - Client',
    EDITOR_INSERT_SOURCE_CLICKED = 'Editor - Insert Source Clicked - Client',
    EDITOR_GLOSSARY_SUGGESTION_CLICKED = 'Editor - Glossary Suggestion Clicked - Client',
    EDITOR_TOGGLE_MARK_AS_REVIEWED_CLICKED = 'Editor - Toggle - Mark as Reviewed - Client',
    EDITOR_TOGGLE_AUTOCOMPLETE_CLICKED = 'Editor - Toggle - Autocomplete - Client',
    EDITOR_TOGGLE_PLACEHOLDER_WRAPPING_CLICKED = 'Editor - Toggle - Placeholder wrapping - Client',
    EDITOR_ADD_KEY_BUTTON_CLICKED = 'Editor - Add Key Button Clicked - Client',
    EDITOR_FIND_REPLACE_CLICKED = 'Editor - Find and Replace Clicked - Client',
    EDITOR_FILES_WIDGET_CLICKED = 'Editor - Files Widget Clicked - Client',
    EDITOR_EDIT_CLOSE_CLICKED = 'Editor - Edit Close Clicked - Client',
    EDITOR_SEARCH_FOCUS_CLICKED = 'Editor - Focus Search Input Clicked - Client',

    // Editor - Key Modal
    EDITOR_KEY_MODAL_OPENED = 'Editor Key Modal - Modal Opened - Client',
    EDITOR_KEY_MODAL_CLOSED = 'Editor Key Modal - Modal Closed - Client',
    EDITOR_KEY_MODAL_SAVE_CLICKED = 'Editor Key Modal - Save Button Clicked - Client',
    EDITOR_KEY_MODAL_TAB_CHANGED = 'Editor Key Modal - Tab Changed - Client',

    EDITOR_TOGGLE_PLACEHOLDERS_CLICKED = 'Editor - Toggle - Display placeholders as blocks - Client',
    EDITOR_TOGGLE_REFERENCE_AS_TEXT_CLICKED = 'Editor - Toggle - Display key references as text - Client',
    EDITOR_TOGGLE_SOURCE_DIFFERENCE_CLICKED = 'Editor - Toggle - Show source difference since it was last translated - Client',
    EDITOR_TOGGLE_FOCUS_MODE_CLICKED = 'Editor - Toggle - Focus mode - Client',
    EDITOR_TOGGLE_SPELL_CHECKING_CLICKED = 'Editor - Toggle - Display spelling and grammar errors - Client',
    EDITOR_TOGGLE_REMEMBER_POSITION_CLICKED = 'Editor - Toggle - Remember position in project - Client',
    EDITOR_LANGUAGE_ADD_CLICKED = 'Editor - Language Add Clicked - Client',
    EDITOR_LANGUAGE_SELECTOR_CLICKED = 'Editor - Language selector Clicked - Client',
    EDITOR_LANGUAGE_SELECTED = 'Language selector - Language selected - Client',
    EDITOR_LANGUAGE_SELECT_ALL = 'Language selector - Select all - Client',
    EDITOR_LANGUAGE_DESELECT_ALL = 'Language selector - Deselect all - Client',
    EDITOR_SELECT_MISSING_PLACEHOLDER_CLICKED = 'Editor - Select Missing Placeholder Clicked - Client',
    EDITOR_INSERT_NEXT_PLACEHOLDER_CLICKED = 'Editor - Insert next Placeholder Clicked - Client',
    EDITOR_INSERT_MISSING_PLACEHOLDER_CLICKED = 'Editor - Insert missing Placeholder Clicked - Client',

    EDITOR_SEGMENTATION_SPLIT_CLICKED = 'Editor - Segmentation - Split Clicked - Client',
    EDITOR_SEGMENTATION_MERGE_CLICKED = 'Editor - Segmentation - Merge Clicked - Client',

    EDITOR_RIGHT_SIDE_PANEL_COLLAPSED = 'Right-side panel collapsed - Client',
    EDITOR_RIGHT_SIDE_PANEL_EXPANDED = 'Right-side panel expanded - Client',

    EDITOR_TRANSLATION_INPUT_OPENED = 'Editor - Translation text input opened - Client',
    EDITOR_TRANSLATION_UPDATED_TIME = 'Editor - Translation Updated - Time tracked - Client',

    EDITOR_SIDE_PANEL_TAB = 'Editor - Side Panel Tab Clicked - Client',

    // Editor - Key Details
    KEY_DETAILS_KEY_EDITOR_OPENED = 'Editor - Key Details - Key editor opened - Client',
    KEY_DETAILS_PLATFORM_ICONS_CLICKED = 'Editor - Key Details - Platform icons clicked - Client',
    KEY_DETAILS_TAG_CLICKED = 'Editor - Key Details - Tag clicked - Client',
    KEY_DETAILS_ADD_EDIT_TAG_CLICKED = 'Editor - Key Details - Add/Edit tag clicked - Client',
    KEY_DETAILS_FILENAME_CLICKED = 'Editor - Key Details - Filename clicked - Client',
    KEY_DETAILS_ACTION_CLICKED = 'Editor - Key Details - Action clicked - Client',
    KEY_DETAILS_SCREENSHOT_CLICKED = 'Editor - Key Details - Screenshot clicked - Client',

    TRANSLATION_DETAILS_COMMENT_ACTION_CLICKED = 'Editor - Translation comment icon clicked - Client',

    PROFILE_SETTINGS_CLICKED = 'Profile Settings Clicked - Client',
    KEYBOARD_SHORTCUT_HELP_CLICKED = 'Keyboard shortcut help Clicked - Client',

    DOWNLOAD_PREVIEW_REFRESH_CLICKED = 'Download Preview - Refresh Clicked - Client',

    SIGNED_IN = 'Signed In - Client',
    SIGNED_OUT = 'Signed Out - Client',
    REGISTRATION_FORM_COMPLETED = 'Registration Form Completed - Client',
    PROJECT_CREATED = 'Project Created - Client',
    PROJECT_OPEN_CREATION_MODAL_CREATED = 'Project - Open New Project Clicked - Client',
    PROJECT_CREATE_SUBMIT_CLICKED = 'Project - New Project Submit Clicked - Client',
    FILE_UPLOAD_STARTED = 'File Upload Started - Client',
    FILE_UPLOAD_FAILED = 'File Upload Failed - Client',
    FILE_UPLOAD_ALERT = 'File Upload Got Alert - Client',
    FILE_UPLOADED = 'File Uploaded - Client',
    FILE_DOWNLOADED = 'File Downloaded - Client',
    TASK_CREATED = 'Task Created - Client',
    TASK_CHANGE_TAB_CLICKED = 'New Task - Tab change clicked - Client',
    TASK_FROM_TEMPLATE_CREATED = 'Task Created (From Template) - Client',
    TASK_CLOSED = 'Task Closed - Client',
    OFFLINE_XLIFF_DOWNLOADED_TASKS = 'Offline XLIFF Downloaded (Tasks) - Client',
    OFFLINE_XLIFF_UPLOADED_TASKS = 'Offline XLIFF Uploaded (Tasks) - Client',
    OFFLINE_XLIFF_DOWNLOADED_EDITOR = 'Offline XLIFF Downloaded (Editor) - Client',
    OFFLINE_XLIFF_UPLOADED_EDITOR = 'Offline XLIFF Uploaded (Editor) - Client',
    LANGUAGE_ADDED = 'Language Added - Client',
    TRANSLATION_ORDER_SUBMITTED = 'Translation Order Submitted - Client',
    TRANSLATION_UPDATED = 'Translation Updated - Client',
    REDIRECT_BACK = 'Redirect superuser back - Client',

    BILLING_UPDATED = 'Billing Updated - Client',
    SEARCHED_PROJECTS_DASHBOARD = 'Searched - Projects Dashboard - Client',
    SEARCHED_EDITOR = 'Searched - Editor - Client',
    PROJECT_VIEWED = 'Project Viewed - Client',
    NEW_CONTRIBUTOR_ADDED = 'New contributor added - Client',
    EXISTING_CONTRIBUTOR_ADDED = 'Existing contributor added - Client',
    USER_GROUP_ADDED = 'User group added - Client',
    CONTRIBUTORS_IMPORTED = 'Contributors Imported - Client',
    PROJECT_FILTERED = 'Project Filtered - Client',
    BILINGUAL_VIEW_SELECTED = 'Bilingual View selected - Client',
    MULTILINGUAL_VIEW_SELECTED = 'Multilingual View selected - Client',
    KEY_ADDED = 'Key added - Client',
    KEY_UPDATED = 'Key updated - Client',
    KEY_DELETED = 'Key deleted - Client',
    SINGLE_KEY_SELECTED = 'Single key selection changed - Client',
    MULTIPLE_KEYS_SELECTED = 'Multiple keys selection changed - Client',
    ALL_KEYS_SELECTED = 'All keys selection changed - Client',
    TRANSLATION_REVIEWED = 'Translation reviewed - Client',
    TRANSLATION_VERIFIED = 'Translation verified - Client',
    CUSTOM_TRANSLATION_STATUS_UPDATED_FOR_TRANSLATION = 'Custom Translation Status Updated for Translation - Client',
    ADD_CUSTOM_TRANSLATION_STATUS_TRANSLATION = 'Add Custom Translation Status for Translation - Client',

    GLOSSARY_VIEWED = 'Glossary Viewed - Client',
    GLOSSARY_TERM_ADDED = 'Glossary term Added - Client',
    GLOSSARY_TERM_UPDATED = 'Glossary term Updated - Client',
    GLOSSARY_DOWNLOADED = 'Glossary Downloaded - Client',
    GLOSSARY_UPLOADED = 'Glossary Uploaded - Client',
    GLOSSARY_VIEW_SWITCH_GRID = 'Glossary - Grid View Selected - Client',
    GLOSSARY_VIEW_SWITCH_LIST = 'Glossary - List View Selected - Client',
    GLOSSARY_TERM_DELETED = 'Glossary Term Deleted - Client',
    GLOSSARY_DELETED_ALL = 'Glossary - Deleted All - Client',
    GLOSSARY_TERMS_EXTRACTED = 'Glossary - Terms Extracted - Client',
    GLOSSARY_SEARCH_PERFORMED = 'Glossary - Search performed - Client',

    BULK_ACTION_TRIGGERED = 'Bulk Action Triggered - Client',

    AUTOMATION_RULE_ADDED = 'Automation Rule Added - Client',
    AUTOMATION_RULE_DELETED = 'Automation Rule Deleted - Client',
    TRANSLATION_MEMORY_CREATED = 'Translation Memory - Created - Client',
    TRANSLATION_MEMORY_UPLOADED = 'Translation Memory - Uploaded - Client',
    VENDOR_ADDED = 'Vendor Added - Client',
    VENDOR_DELETED = 'Vendor Deleted - Client',
    VENDORS_MEMBER_ADDED = 'Vendors - Member Added - Client',
    VENDORS_MEMBER_REMOVED = 'Vendors - Member Removed - Client',
    VENDORS_RATE_CARD_ADDED = 'Vendors - Rate Card Added - Client',
    VENDORS_RATE_CARD_DELETED = 'Vendors - Rate Card Deleted - Client',
    VENDORS_RATE_CARD_ARCHIVED = 'Vendors - Rate Card Archived - Client',
    VENDORS_REPORT_DOWNLOADED = 'Vendors - Report Downloaded - Client',
    SSO_CONFIGURED = 'SSO configured - Client',
    SCREENSHOT_VIEWED = 'Screenshots Viewed - Client',
    SCREENSHOT_UPLOADED = 'Screenshots Uploaded - Client',
    SCREENSHOT_LINKED = 'Screenshots Linked - Client',
    SCREENSHOT_COORDINATES_SAVE_CLICKED = 'Screenshots Coordinates Save Clicked - Client',
    SCREENSHOT_SAVE_CLICKED = 'Screenshots Save Clicked - Client',
    TRANSLATION_HISTORY_VIEWED = 'Translation History viewed - Client',
    TRANSLATION_MEMORY_CONCORDANCE_SEARCH_VIEWED = 'Translation Memory - Concordance Search Viewed - Client',
    TRANSLATION_MEMORY_SIDE_PANEL_VIEWED = 'Translation Memory - Right Side Panel Search Viewed - Client',
    BRANCHING_ENABLED = 'Branching enabled - Client',
    BRANCH_MERGED = 'Branch merged - Client',
    PROJECT_SORTED = 'Project Sorted - Client',
    SKD_TOKEN_GENERATED = 'SDK Token generated - Client',
    API_TOKEN_GENERATED = 'API token generated - Client',
    PROJECT_DASHBOARD_SEARCHED = 'Project Dashboard Searched - Client',
    PROJECT_FILTERED_PREDEFINED = 'Project Filtered (Predefined) - Client',
    INTEGRATION_CLICKED = 'Integration Clicked - Client',
    SEATS_ADDED = 'Seats Added - Client',
    TEAM_CREATED = 'Team Created - Client',
    PLAN_UPDATED = 'Plan Updated - Client',
    USER_GROUP_CREATED = 'User Group Created - Client',
    BRANCH_DELETED = 'Branch Deleted - Client',
    BRANCH_ADDED = 'Branch Added - Client',
    BRANCH_CREATE_CLICKED = 'Branch Create Clicked - Client',
    PROJECT_DELETED = 'Project Deleted - Client',
    PROJECT_ACTIVITY_VIEWED = 'Project Activity Viewed - Client',
    PROJECT_ADD_CLICKED = 'Project - Add Project Clicked - Client',
    DUPLICATE_LINKED = 'Duplicate Linked - Client',
    ALL_DUPLICATES_LINKED = 'All Duplicates Linked - Client',
    CHAT_OPENED = 'Chat Opened - Client',
    CHAT_MESSAGE_SENT = 'Chat Message Sent - Client',
    TASK_NAME_IN_EDITOR_CLICKED = 'Task - Task name in Editor clicked - Client',
    TASK_WIDGET_OPENED = 'Task Widget Opened - Client',
    TASK_WIDGET_TASK_CLICKED = 'Task Widget - Task Clicked - Client',
    TASK_WIDGET_TASK_NAME_CLICKED = 'Task widget - Task name clicked - Client',
    TASK_WIDGET_LANGUAGE_CLICKED = 'Task widget - Task language clicked - Client',
    TASK_WIDGET_MARK_AS_DONE_CLICKED = 'Task widget - Mark as done button clicked - Client',
    TASK_WIDGET_WORDCOUNT_CLICKED = 'Task widget - Wordcount clicked - Client',
    QA_CHECKS_UPDATED = 'QA Checks Updated - Client',
    TASK_INITIAL_ANALYSIS_DOWNLOADED = 'Task - Initial Analysis Downloaded - Client',
    TASK_FINAL_REPORT_DOWNLOADED = 'Task - Final Report Downloaded - Client',
    TASK_DETAILED_TRANSLATION_REPORT_DOWNLOADED = 'Task - Detailed Translation Report Downloaded - Client',
    SNAPSHOT_CREATED = 'Snapshot created - Client',
    NOTIFICATIONS_UPDATED = 'Notifications Updated - Client',
    TRANSLATION_REPORT_DOWNLOADED = 'Translation Report Downloaded - Client',
    EMAIL_UPDATED = 'Email Updated - Client',
    PROJECT_FILTERED_CUSTOM = 'Project Filtered (Custom) - Client',
    PROJECT_MIGRATED = 'Project Migrated - Client',
    PERSONAL_PROFILE_UPDATED = 'Personal Profile Updated - Client',
    TEAM_DELETED = 'Team Deleted - Client',
    AUTOMATION_RULE_UPDATED = 'Automation Rule Updated - Client',
    SUBSCRIPTION_RESUMED = 'Subscription Resumed - Client',
    OPEN_SUBMIT_APP_INTEREST_FORM = 'Open Build your own app Form - Client',
    OPEN_APP_INFO_MODAL = 'Open app info modal - Client',

    END_OF_TRIAL_CLICK_UPGRADE_TO_PAID_PLAN = 'Upgrade to paid plan clicked - Client',
    END_OF_TRIAL_CLICK_COMPARE_ALL_PLANS = 'Compare all plans clicked - Client',
    END_OF_TRIAL_CLICK_DOWNGRADE_TO_FREE = 'Downgrade to free plan clicked - Client',
    END_OF_TRIAL_CLICK_TALK_TO_SALES = 'Get in touch with sales clicked - Client',

    NEW_VERSION_NOTIFICATION_SHOWN = 'New version notification shown - Client',

    NEW_TEAM_MEMBER_ADDED = 'New team member(-s) added - Client',
    NEW_PROJECT_CONTRIBUTOR_ADDED = 'New Contributor Added - Client',
    ADD_USER_GROUP_TO_PROJECT = 'User Group Added - Client',
    ADD_EXISTING_CONTRIBUTOR = 'Existing Contributor Added - Client',
    NEW_MEMBER_ADDED_TO_USER_GROUP = 'New member added to User Group - Client',
    EXISTING_MEMBER_ADDED_TO_USER_GROUP = 'Existing member added to User Group - Client',

    DESIGN_PLUGINS_AD_LIKED = 'Design plugin ad liked - Client',
    DESIGN_PLUGINS_AD_DISLIKED = 'Design plugin ad disliked - Client',
    DESIGN_PLUGINS_BUTTON_CLICKED = 'Try design plugins button clicked - Client',

    NEW_CARD_ADDED = 'New Card Added - Client',

    COMMENTS_SIDEBAR_OPENED = 'Comments Sidebar Opened - Client',
    COMMENT_ADDED = 'Comment added - Client',
    COMMENT_CLICKED = 'Comment clicked - Client',
    COMMENT_DELETED = 'Comment deleted - Client',
    COMMENT_EDITED = 'Comment edited - Client',
    COMMENT_RESOLVED = 'Comment Resolved - Client',
    THREAD_OPENED = 'Comment Thread Opened - Client',
}

export default AnalyticsEventName;
